<div class="org-progress" *ngIf="progress">
  <mat-progress-bar class="org-progress__bar" mode="indeterminate" *ngIf="!progress.completed && !progress.errorKey">
  </mat-progress-bar>

  <div class="org-progress__steps">
    <div class="org-progress__step"
      *ngFor="let step of progress.steps"
      [class.is-done]="step.status === 'done'"
      [class.is-active]="step.status === 'running'"
      [class.is-failed]="step.status === 'failed'">
      <icon [name]="stepIcon(step)" width="18" height="18" class="org-progress__step-icon"></icon>
      <span>{{ stepLabelKey(step) | translate: { old: progress.oldName, org: progress.targetName } }}</span>
    </div>
  </div>

  <div class="org-progress__error" *ngIf="progress.errorKey">
    <icon name="warning" width="18" height="18"></icon>
    <span>{{ progress.errorKey | translate: { org: progress.targetName } }}</span>
  </div>

  <div class="org-progress__actions" *ngIf="showRunInBackground && !progress.completed && !progress.errorKey">
    <button mat-stroked-button color="primary" type="button" id="btn_preferredOrgRunInBackground"
      (click)="runInBackground.emit()">
      {{ 'preferredOrg.runInBackground' | translate }}
    </button>
  </div>
</div>
